module.exports = __webpack_public_path__ + "static/img/报废.68785750.png";